// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__328c9","skeleton":"styles_skeleton__Ob8Rn"};